import * as ng from 'angular';

export const StTable = () => (<angular.IDirective>{

    restrict: 'A',
    controller: 'stTableController',
    link: (scope, element, attr, ctrl) => {
        // _?
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-table/st-table.directive.ts